import { MESSAGE_KEY_CUSTOM_VALIDATE_MESSAGE } from "../../core/const/Constant";
import { useSubcribeWindowMessage } from "./useSubcribeWindowMessage";

/**
 * 
 * This using for custom message that passed from Form Script Embeder
 * Receive message from parent site
 */
export const useMessageValidation = (() => {

    let customValidMessage = {};
    useSubcribeWindowMessage(MESSAGE_KEY_CUSTOM_VALIDATE_MESSAGE, value => {
        customValidMessage = value;
    })

    /**
     * 
     * @param {string} fieldType
     * @param {string} fieldCode
     * @param {import ('../models/FieldValidationModel').default} validation
     * @returns { string }
     * 
     */
    return (fieldType, fieldCode, validation) => {
        const { rule, format, message } = validation;
        const existedField = customValidMessage[fieldType] || customValidMessage[fieldCode];
        if (!!existedField && !!existedField[rule]) {
            return existedField[rule].replace('$VALUE', format || '');
        } else {
            return message;
        }
    };
})();
